gsap.set(".co-footer-crumble_1 img", { rotate: 0, x: "0%", y: "0%" });
gsap.to(".co-footer-crumble_1 img", {
  scrollTrigger: {
    trigger: ".co-footer",
    start: "-=60 bottom",
    end: "center top",
    scrub: true
  },
  x: "30%",
  y: "5%",
  rotate: 25,
});
gsap.set(".co-footer-crumble_2 img", { rotate: 0, x: "0%", y: "0%" });
gsap.to(".co-footer-crumble_2 img", {
  scrollTrigger: {
    trigger: ".co-footer-crumble_2",
    start: "top bottom",
    end: "bottom top",
    scrub: true
  },
  x: "15%",
  y: "-5%",
  rotate: -10,
});